"use client";

import Link from "next/link";
import { useState } from "react";
import { FaEnvelope } from "react-icons/fa";
import AuthCard from "@/components/auth/auth-card";
import Button from "@/components/ui/button";
import FormControl from "@/components/ui/form-control";
import FormGroup from "@/components/ui/form-group";
import InputText from "@/components/ui/input-text";
import { useFormContext } from "@/providers/form.provider";
import type { Login } from "@/types/containers/auth/login";
import { apiClient } from "@/utils/api/api-client";
import VerifyOtp from "../verify-otp";

const LoginCard = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [userDetails, setUserDetails] = useState<{
    identifier: string;
    userId: string;
  } | null>(null);

  const { setError } = useFormContext<Login>();

  return (
    <AuthCard
      isLoading={isLoading}
      heading={!userDetails ? "Welcome" : "Enter OTP"}
      subHeading={
        !userDetails
          ? "Enter your account details to log in."
          : "Enter the 6-digit OTP sent to your email"
      }
    >
      {!userDetails ? (
        <>
          {/* Email */}
          <FormGroup
            onSubmit={async (values, errors) => {
              if (errors) {
                return;
              }
              const { identifier } = values as Login;
              setIsLoading(true);
              apiClient
                .post<
                  { success: boolean; userId: string },
                  { identifier: string }
                >("/auth/request-otp", {
                  identifier,
                })
                .then((resp) => {
                  if (resp.success) {
                    setUserDetails({ identifier, userId: resp.userId });
                  }
                })
                .catch((e: ApiError) => {
                  // Temporary change for demo - phone numbers
                  const isPhoneNumber = /^\d{10,15}$/.test(identifier);
                  if (e.error.code === "USER_NOT_FOUND" && isPhoneNumber) {
                    setError("identifier", { message: e.error.message });
                    return;
                  }
                  if (isPhoneNumber) {
                    setUserDetails({ identifier, userId: e.userId });
                    return;
                  }
                  setError("identifier", { message: e.error.message });
                })
                .finally(() => setIsLoading(false));
            }}
          >
            <FormControl hasIcon isRequired name="identifier" label="Email ID">
              <InputText leftIcon={FaEnvelope} />
            </FormControl>

            {/* Button */}
            <Button fullWidth size="lg">
              Continue
            </Button>
          </FormGroup>

          {/* Join */}
          <div className="space-y-2">
            <p className="text-center text-sm text-slate-600">
              Don’t have an account?{" "}
              <Link
                href="/signup"
                className="font-medium text-primary-500 hover:underline"
              >
                Join ReEquip
              </Link>
            </p>

            {/* <p className="text-center text-xs">
              <Link
                href="/forgot-identifier"
                className="font-medium text-primary-500 text-sm hover:underline"
              >
                Forgot Email?
              </Link>
            </p> */}
          </div>
        </>
      ) : (
        <VerifyOtp userDetails={userDetails} />
      )}
    </AuthCard>
  );
};

export default LoginCard;
